import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.page');
import { OnInit } from "@angular/core";

@Component({
    selector: 'wiz-component-page',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.page/view.scss */
@charset "UTF-8";
/* Korean */
@import url("css2?family=Noto+Serif+KR:wght@200..900&display=swap");
@import url("css2?family=Nanum+Gothic&display=swap");
/* English */
@import url("css2?family=Noto+Serif+KR:wght@200..900&family=Noto+Serif:ital,wght@0,100..900;1,100..900&display=swap");
@import url("css2?family=Elms+Sans:ital,wght@0,100..900;1,100..900&family=Noto+Serif+KR:wght@200..900&family=Noto+Serif:ital,wght@0,100..900;1,100..900&display=swap");
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* font */
.noto-korean {
  font-family: "Noto Serif KR", serif;
}

.nanum-korean {
  font-family: "Nanum Gothic", sans-serif;
}

.noto-english {
  font-family: "Noto Serif", serif;
}

.sans-english {
  font-family: "Elms Sans", sans-serif;
}

/* body */
.container {
  margin-top: 48px;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  background: linear-gradient(to bottom right, #dbdbcd, #506cc9);
  min-height: 100vh;
  padding: 48px 24px;
  position: relative;
}

body::before {
  content: "";
  position: fixed;
  inset: 0;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmYjkyM2MiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDE0aDRWMGgtNHYxNHpNMCA0aDRWMEgwdjR6bTI0IDI0aDRWMjRoLTR2NHpNMTIgNDhoNHYtNGgtNHY0em0yNC0yNGg0di00aC00djR6Ii8+PC9nPjwvZz48L3N2Zz4=");
  opacity: 0.4;
  pointer-events: none;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
}

header {
  padding: 48px 0;
  text-align: center;
}

h1 {
  font-size: 5rem;
  font-weight: 700;
  background: #334155;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-bottom: 12px;
}

.subtitle {
  color: #334155;
  font-size: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  min-height: 650px;
}

@media (max-width: 1024px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
.card {
  background: rgba(175, 182, 255, 0.327);
  backdrop-filter: blur(40px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.card-header {
  padding: 24px;
  border-bottom: 1px solid #407214;
  background: rgba(189, 48, 48, 0);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.icon-box {
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-box.teal {
  background: rgba(23, 89, 195, 0.5);
  border: 1px solid rgba(184, 20, 20, 0);
}

.icon-box.amber {
  background: rgba(194, 127, 11, 0.5);
  border: 1px solid rgba(245, 159, 11, 0);
}

.card-title h2 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}

.card-body {
  flex: 1;
  padding: 24px;
  overflow-y: auto;
}

.upload-zone {
  height: 100%;
  border: 2px dashed #142272;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  padding: 32px;
}

.upload-zone:hover {
  border-color: #4e5ca8;
  background: rgba(151, 178, 251, 0.19);
}

.upload-zone.dragging {
  border-color: #4e5ca8;
  background: rgba(166, 193, 255, 0.1843137255);
  transform: scale(1.02);
}

.upload-icon {
  width: 80px;
  height: 80px;
  border-radius: 16px;
  background: linear-gradient(to bottom right, #6695c3, #cdd1c7);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
}

.upload-text {
  text-align: center;
}

.upload-text p:first-child {
  color: #1e293b;
  font-size: 1rem;
  margin-bottom: 8px;
}

.upload-text p:last-child {
  color: #475569;
  font-size: 0.875rem;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-primary {
  background: linear-gradient #000000;
  color: rgba(17, 110, 128, 0.485);
  margin-top: 12px;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.5);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 25px rgba(208, 179, 13, 0.5);
}

.btn-outline {
  background: rgba(255, 255, 255, 0.5);
  color: #334155;
}

.btn-outline:hover {
  background: #c7cbfe;
}

.preview-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.preview-image-wrapper {
  flex: 1;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  padding: 16px;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.upload-complete {
  position: absolute;
  top: 16px;
  right: 16px;
  padding: 8px 16px;
  border-radius: 9999px;
  background: #22c55e;
  box-shadow: 0 10px 15px rgba(34, 197, 94, 0.3);
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  font-size: 0.875rem;
}

.empty-state,
.loading-state {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.empty-icon {
  width: 80px;
  height: 80px;
  border-radius: 16px;
  background: linear-gradient(to bottom right, #6695c3, #cdd1c7);
  border: 1px solid rgba(255, 255, 255, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
}

.spinner {
  width: 64px;
  height: 64px;
  border: 4px solid rgba(188, 200, 255, 0.5294117647);
  border-top-color: #002dce;
  border-radius: 50%;
  animation: spin 2s linear infinite;
  margin-bottom: 24px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes blink {
  50% {
    opacity: 0;
  }
}
.result-container {
  display: flex;
  flex-direction: column;
  gap: 200px;
}

.result-thumbnail {
  width: 100%;
  height: 192px;
  object-fit: cover;
  border-radius: 12px;
  background: #ffffff;
  margin-bottom: 25px;
}

.result-box {
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(4px);
  border: 1px solid;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 10px;
}

.result-box.teal {
  border-color: rgba(255, 255, 255, 0);
}

.result-box.amber {
  border-color: rgba(255, 255, 255, 0);
}

.result-box.blue {
  border-color: rgba(255, 255, 255, 0);
}

.result-box.orange {
  border-color: rgba(255, 255, 255, 0);
}

.result-box.summary {
  background: linear-gradient #fef3c7;
  border-color: rgba(255, 255, 255, 0);
}

.result-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.result-header h3 {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
}

/* 구조역학 전용 스타일 */
.solution-section {
  margin-bottom: 20px;
}

.solution-section h4 {
  color: #0d9488;
  font-size: 1rem;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #ccfbf1;
}

.solution-content {
  color: #334155;
  line-height: 1.8;
  font-size: 0.95rem;
}

.solution-content p {
  margin-bottom: 12px;
}

.solution-content ul,
.solution-content ol {
  margin-left: 20px;
  margin-bottom: 12px;
}

.solution-content li {
  margin-bottom: 8px;
}

.formula-box {
  background: #f1f5f9;
  border-left: 4px solid #14b8a6;
  padding: 12px 16px;
  margin: 12px 0;
  border-radius: 4px;
  font-family: "Courier New", monospace;
  font-size: 0.9rem;
}

.answer-box {
  background: linear-gradient(to right, #ccfbf1, #fef3c7);
  border: 2px solid #14b8a6;
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;
}

.answer-box strong {
  color: #0d9488;
  font-size: 1.1rem;
}

.step-number {
  display: inline-block;
  width: 28px;
  height: 28px;
  background: linear-gradient(to bottom right, #14b8a6, #0d9488);
  color: white;
  border-radius: 50%;
  text-align: center;
  line-height: 28px;
  font-weight: bold;
  margin-right: 8px;
  font-size: 0.9rem;
}

input[type=file] {
  display: none;
}

.icon {
  width: 20px;
  height: 20px;
}

.icon-lg {
  width: 40px;
  height: 40px;
}

/* Scrollbar */
.card-body::-webkit-scrollbar {
  width: 8px;
}

.card-body::-webkit-scrollbar-track {
  background: rgba(241, 245, 249, 0.5);
  border-radius: 4px;
}

.card-body::-webkit-scrollbar-thumb {
  background: rgba(36, 136, 251, 0.5);
  border-radius: 4px;
}

.card-body::-webkit-scrollbar-thumb:hover {
  background: rgba(36, 93, 251, 0.7);
}

/* 🧭 사이드바 스타일 */
.sidebar.closed {
  transform: translateX(-240px);
}

.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 240px;
  height: 100vh;
  background: #f8fafc;
  border-right: 1px solid #e2e8f0;
  padding: 24px 16px;
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.05);
  overflow-y: auto;
  transition: transform 0.3s ease;
  z-index: 1000;
}

/* 토글 버튼 */
.sidebar-toggle {
  position: fixed;
  top: 20px;
  left: 20px;
  background: #2563eb;
  color: white;
  border: none;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  z-index: 1100;
  font-size: 18px;
}

.sidebar-toggle:hover {
  background: #1e40af;
}

.sidebar h2 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 16px;
  text-align: center;
}

.history-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.history-item {
  font-size: 0.95rem;
  color: #334155;
  padding: 10px 12px;
  margin-bottom: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.model-select {
  display: flex;
}

#modelChoice {
  padding: 6px;
  border-radius: 6px;
  border: 1px solid #ddd;
}

.analyze-button {
  width: 100%;
  padding: 12px;
  margin-top: 10px;
  font-size: 16px;
  font-weight: 600;
  background-color: #2563eb;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.analyze-button:hover {
  background-color: #1d4ed8;
}

.top-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  z-index: 999;
  background: transparent;
}

.logout-btn {
  margin-left: auto;
  background: white;
  border: 1px solid #d0d0d0;
  padding: 10px 12px;
  border-radius: 8px;
  text-decoration: none;
  color: #333;
  font-weight: bold;
}`],
})
export class ComponentPageComponent implements OnInit {
    constructor() {
    }

    public async ngOnInit() {
    }
}

export default ComponentPageComponent;